import React from 'react';
import WOW from '../../../assets/WOW.webp';
import Magenta from '../../../assets/Magenta.webp';
import ZDF from '../../../assets/ZDFwebp.webp';
import ARD from '../../../assets/ARD.webp';
import RTL from '../../../assets/RTL.webp';
import RTLPLUS from '../../../assets/RTL+.webp';
import Joyn from '../../../assets/Joyn.webp';
import waipuu from '../../../assets/waipu.webp';
import vodafone from '../../../assets/vodafone.webp';
import zatoo from '../../../assets/zatoo.webp';
import amazon from '../../../assets/amazonprimepng.png';
import bildplus from '../../../assets/bild.webp';
import dazn from '../../../assets/dazn.webp';
import sky from '../../../assets/sky.webp';
import oTwo from '../../../assets/o2.webp';
import digiturk from '../../../assets/digiturl.webp';
import sporteins from '../../../assets/sport1.webp';
import sportdigital from '../../../assets/sportdigital.webp';
import sateins from '../../../assets/sat1.webp';
import applemls from '../../../assets/apple mls.webp';
import sportworld from '../../../assets/sportworld.webp';

export function getProviderData(
  providerName: string
): { image: string; url: string } | null {
  switch (providerName) {
    case 'MagentaTV - MegaSport':
    case 'MagentaTV - Smart':
    case 'MagentaTV - Flex':
    case 'MagentaTV - Sport':
      return { image: Magenta, url: 'https://www.telekom.de/magenta-tv' }; // MagentaTV

    case 'ZDF - Free-TV':
      return { image: ZDF, url: 'https://www.zdf.de' }; // ZDF

    case 'ARD - Free-TV':
      return { image: ARD, url: 'https://www.ard.de' }; // ARD

    case 'RTL+ - Premium':
      return { image: RTL, url: 'https://plus.rtl.de/' }; // RTL+

    case 'RTL - Free-TV':
      return { image: RTLPLUS, url: 'https://www.rtl.de' }; // RTL

    case 'WOW - Live-Sport':
      return { image: WOW, url: 'https://www.wowtv.de' }; // WOW

    case 'Joyn - Standard':
      return { image: Joyn, url: 'https://www.joyn.de' }; // Joyn

    case 'waipu.tv - Comfort':
    case 'waipu.tv - Perfect Plus':
    case 'waipu.tv - Perfect Plus DAZN':
      return { image: waipuu, url: 'https://www.waipu.tv' }; // Waipu.tv

    case 'Vodafone - GigaTV Cable':
    case 'Vodafone - GigaTV Cable Premium Plus':
      return { image: vodafone, url: 'https://www.vodafone.de' }; // Vodafone

    case 'Zattoo - FREE':
    case 'Zattoo - SMART HD':
    case 'Zattoo - SMART HD mit Plus Sport':
      return { image: zatoo, url: 'https://www.zattoo.com' }; // Zattoo

    case 'Amazon - Prime Video':
      return { image: amazon, url: 'https://www.amazon.de/prime' }; // Amazon Prime Video

    case 'Bildplus/Amazon - Bildplus/Amazon Prime Video':
      return { image: bildplus, url: 'https://www.bild.de' }; // Bildplus

    case 'DAZN - Unlimited':
    case 'DAZN - World':
    case 'DAZN - Super Sports':
    case 'DAZN - Free':
      return { image: dazn, url: 'https://www.dazn.com' }; // DAZN

    case 'Sky - Bundesliga':
    case 'Sky - Sport':
    case 'Sky - Sport und Bundesliga':
      return { image: sky, url: 'https://www.sky.de' }; // Sky

    case 'Sport1 - Free-TV':
      return { image: sporteins, url: 'https://www.sport1.de' }; // Sport1

    case 'Sportdigital - Free':
    case 'Sportdigital - Premium':
      return { image: sportdigital, url: 'https://www.sportdigital.de' }; // Sportdigital

    case 'Sat1 - Free-TV':
      return { image: sateins, url: 'https://www.sat1.de' }; // Sat1

    case 'Bild - Bildplus':
      return { image: bildplus, url: 'https://www.bild.de' }; // Bildplus

    case 'Digiturk - Fußball + Family':
      return { image: digiturk, url: 'https://www.digiturk.com.tr' }; // Digiturk

    case 'O2 - TV M':
    case 'O2 - TV M mit Pay-TV':
      return { image: oTwo, url: 'https://www.o2.de' }; // O2

    case 'Apple - MLS Season Pass':
      return {
        image: applemls,
        url: 'https://tv.apple.com/de/channel/mls-season-pass/tvs.sbd.7000',
      }; // Apple

    case 'SportWorld - Samsung Sport Paket':
      return {
        image: sportworld,
        url: 'https://www.samsung.com/de/offer/madeforgermany/sportworld/',
      };

    default:
      return null;
  }
}
